import React from "react";

// Local Imports
import Brody from "../../images/tradional_painting/Brody_Oil_Painting.JPG";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function TP_Project_4() {
  // Brody Pet Portrait
  const openPopupBoxBrody = () => {
    const content = (
      <>
        <div className="image-center">
          <img
            className="portfolio-image-popupbox-constraints"
            src={Brody}
            alt="A beautifully oil-painted commission piece of an english bulldog"
          />
        </div>
        <p>A beautifully oil-painted commission piece of an english bulldog</p>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Brody Pet Portrait",
        },
      },
    });
  };

  const popupboxConfigBrody = {
    titleBar: {
      enable: true,
      text: "Brody Pet Portrait",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div className="portfolio-image-box" onClick={openPopupBoxBrody}>
        <img
          className="portfolio-image constraints image-middle-center"
          src={Brody}
          alt="A beautifully oil-painted commission piece of an english bulldog"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigBrody} />
    </>
  );
}

export default TP_Project_4;
